// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"1d9806b5","945":"67460c2b"}[chunkId] + ".chunk.css";
};